import React from 'react';
import Spin from 'components/Spin';

const LoadingSpin = ({ children }) => {
  return (
    <Spin spinning={false} tip={'Loading...'}>
      {children}
    </Spin>
  );
};

export default LoadingSpin;
